import { render, staticRenderFns } from "./HotelManagement.vue?vue&type=template&id=6f4c8210&scoped=true"
import script from "./HotelManagement.vue?vue&type=script&lang=js"
export * from "./HotelManagement.vue?vue&type=script&lang=js"
import style0 from "./HotelManagement.vue?vue&type=style&index=0&id=6f4c8210&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4c8210",
  null
  
)

export default component.exports